/* ------------------- Pseudo-React createElement Function ------------------------- */
export function createElement (tag, attrs, children) {
    var element = document.createElement(tag);

    for (let name in attrs) {
        if ( name && attrs.hasOwnProperty(name) ) {
            let value = attrs[name];
            if (value === true) {
                element.setAttribute(name, name);
            } else if (value !== false && value != null) {
                element.setAttribute(name, value.toString());
            }
        }
    }

    for (let i = 2; i < arguments.length; i++) {
        let child = arguments[i];
        element.appendChild(
            child.nodeType == null ?
                document.createTextNode(child.toString()) : child);
    }

    return element;
}

/* ------------------- Smooth scroll into View ------------------------- */
export function scrollToElement( element = null, hash = '', offset = 0) {
    if (!(element instanceof HTMLElement) && hash.length > 2 && hash.indexOf('#') >= 0) {
      element = document.querySelector( hash );
    }
    if ( element && element instanceof HTMLElement ) {
      let y = element.getBoundingClientRect().top + window.scrollY - offset;
      window.scrollTo({top: y, behavior: 'smooth'});
    } else {
      console.log('Element: %o, Hash: %s', element, hash);
    }
}